import { useTranslation } from "react-i18next";
import { PurchaseOrderEvent } from "../../../types";
import { formatDateTime } from "../../../utils/utils";

interface OcTimelineProps {
  events: PurchaseOrderEvent[];
}

const time = (e: PurchaseOrderEvent): number =>
  e.date ? new Date(e.date).getTime() : 0;

/**
 * The OC's history, oldest first (the order the backend sends; re-sorted defensively, stable on
 * ties). Each entry shows the TRANSLATED event type — never the raw enum — plus when, who and the
 * reason/detail when present.
 */
const OcTimeline = ({ events }: OcTimelineProps) => {
  const { t } = useTranslation();
  const sorted = events
    .map((event, index) => ({ event, index }))
    .sort((a, b) => time(a.event) - time(b.event) || a.index - b.index)
    .map(({ event }) => event);

  return (
    <ol className="oc-timeline" aria-label={t("purchaseOrders.detail.history")}>
      {sorted.map((event) => (
        <li key={event.id} className="oc-timeline__item">
          <p className="oc-timeline__title">
            {t(`purchaseOrders.event.${event.type}`, {
              defaultValue: event.type,
            })}
          </p>
          <p className="oc-timeline__meta">
            {[event.date ? formatDateTime(event.date) : null, event.actorName]
              .filter(Boolean)
              .join(" · ")}
          </p>
          {event.reason ? (
            <p className="oc-timeline__text">
              <span className="oc-timeline__label">
                {t("purchaseOrders.detail.reason")}:
              </span>{" "}
              {event.reason}
            </p>
          ) : null}
          {event.detail ? (
            <p className="oc-timeline__text">{event.detail}</p>
          ) : null}
        </li>
      ))}
    </ol>
  );
};

export default OcTimeline;
